import { SourceType } from '@wix/a11y-rules';
import { Box, Image } from '@wix/design-system';
import { Music, Reels } from '@wix/wix-ui-icons-common';
import React, { useMemo } from 'react';
import { HTTP_PREFIX } from '../../../../consts';
import { resolveImageUrl } from '../../../../utils/resolve-image-url';
import { extractMediaUri } from '../../alt-image-fixer/utils/extract-media-uri';
import { convertYouTubeToThumbnail, isFacebookReelUrl, isInstagramReelUrl, isTikTokVideoUrl, isVimeoVideoUrl } from './media-alternative-rule-thumbnail-utils';
const MEDIA_ICONS = {
  [SourceType.VIDEO]: Reels,
  [SourceType.AUDIO]: Music
};
const MediaAlternativeRuleThumbnail = _ref => {
  let {
    sourceType = SourceType.VIDEO,
    uri = ''
  } = _ref;
  const extractedUri = extractMediaUri(uri);
  const urlToShow = useMemo(() => {
    const youtubeThumbnail = convertYouTubeToThumbnail(uri);
    if (youtubeThumbnail) {
      return youtubeThumbnail;
    }
    if (isVimeoVideoUrl(uri) || isFacebookReelUrl(uri) || isInstagramReelUrl(uri) || isTikTokVideoUrl(uri)) {
      return undefined;
    }
    if (uri.startsWith(HTTP_PREFIX)) {
      return uri;
    }
    return resolveImageUrl(extractedUri, 50, 50);
  }, [uri, extractedUri]);
  const MediaIcon = sourceType ? MEDIA_ICONS[sourceType] : Reels;
  return /*#__PURE__*/React.createElement(Box, null, urlToShow && uri ? /*#__PURE__*/React.createElement(Image, {
    borderRadius: "3px",
    fit: "cover",
    height: "30px",
    src: urlToShow,
    width: "30px"
  }) : /*#__PURE__*/React.createElement(Box, {
    align: "center",
    color: "D10",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(MediaIcon, null)));
};
export default MediaAlternativeRuleThumbnail;
//# sourceMappingURL=media-alternative-rule-thumbnail.js.map